<template>
  <div
    ref="con"
    class="bill-container"
  >
    <van-tabs
      v-model="activeTab"
      sticky
      @click="onClickTab"
    >
      <van-tab
        title="未出账单"
        name="unbill"
      >
        <UnbilledList ref="unbilledList" />
      </van-tab>
      <van-tab
        title="已出账单"
        name="billed"
      >
        <BilledList ref="billedList" />
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Tabs from 'vant/lib/tabs';
import Tab from 'vant/lib/tab';
import UnbilledList from '@/views/bill/components/UnbilledList';
import BilledList from '@/views/bill/components/BilledList';
import tracker from '@/util/tracker';

import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';

export default {
  name: 'BillList',
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    UnbilledList,
    BilledList,
  },
  data() {
    const { tab = 'unbill' } = this.$route.query;
    return {
      activeTab: tab,
      cid: this.$CID.BillList,
      scrollTop: 0,
    };
  },
  activated() {
    const ref = this.$refs.con;
    if (ref) {
      const scrollTop = this.scrollTop;
      ref.scrollTop = scrollTop;
    }
  },
  methods: {
    onClickTab() {
      if (this.activeTab === 'unbill' && this.$refs.unbilledList) {
        this.$refs.unbilledList.init();
      } else if (this.activeTab === 'billed' && this.$refs.billedList) {
        this.$refs.billedList.init();
      }

      if (this.activeTab === 'billed') {
        tracker.sendModuleClick(this.$BID.BILL_LIST_BILLED_MC, null, { cid: this.cid });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'Home') {
      this.$route.meta.keepAlive = false;
    }
    const ref = this.$refs.con;
    if (ref) {
      this.scrollTop = ref.scrollTop;
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/page/bill.scss';
.bill-container {
  height: 100vh;
  overflow: auto;
}
</style>
